import { validators, z } from '../utils';
import { makeFormComponent, makeFormHook } from '../utils/factory';
import type { InferFormType } from '../utils/types';

const acceptInviteFormSchema = z
  .object({
    confirmPassword: validators.password(),
    email: validators.email(),
    firstName: validators.requiredString('First name'),
    lastName: validators.requiredString('Last name'),
    password: validators.password(),
    phoneNumber: validators.e164PhoneNumber(),
    preferredName: validators.optionalString(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

export type AcceptInviteFormSchema = InferFormType<typeof acceptInviteFormSchema>;

export const acceptInviteFormDefaultValues: AcceptInviteFormSchema = {
  confirmPassword: '',
  email: '',
  firstName: '',
  lastName: '',
  password: '',
  phoneNumber: '',
  preferredName: '',
};

export const useAcceptInviteForm = makeFormHook(acceptInviteFormSchema, acceptInviteFormDefaultValues);

export const AcceptInviteForm = makeFormComponent(acceptInviteFormSchema, acceptInviteFormDefaultValues);
